import { Component, ElementRef, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { ExecutionChartDataDto, ExecutionSummaryDto, GetExecutionChartCommandRequest, GetExecutionChartCommandResponse, ProjectDto, ProjectSetupDto } from '../../data/CommandServiceDtos.generated';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { curveLinear } from 'd3-shape';
import { PageContainerService } from '../../services';
import { SCurveService } from '../../services/scurve.service';

@Component({
  selector: 'project-execution-scurve',
  templateUrl: './project-execution-scurve.component.html',
  styleUrls: ['./project-execution-scurve.component.scss']
})
export class ProjectExecutionScurveComponent implements OnInit {
  startDate: any;
  endDate: any;
  savedStartDate: any;
  savedEndDate: any;
  seeFullSchedule: boolean = false;

  // colorScheme = { domain: ['#5AA454', '#A10A28', '#C7B42C', '#AAAAAA'] };
  colorScheme = {
    domain: ['#E44D25', '#5AA454', '#a08f35']
  };

  customColors = [];

  @Input() chartData: ExecutionChartDataDto[];
  @Input() executionSummary: ExecutionSummaryDto;
  @Input() projectId: number;
  @Input() project: ProjectSetupDto = new ProjectSetupDto;
  @Input() projectTargetStart: string;
  @Input() projectTargetStartMIN: string;
  @Input() projectTargetFinish: string;
  @Input() projectedData: string;
  @Input() projectTargetFinishMAX: string;
  @Input() baselineTargetFinish: string;
  @Input() projectDataDate: string;

  curve: any = curveLinear;
  legend: boolean = false;
  showGridLines: boolean = true;
  animations: boolean = true;
  xAxis: boolean = true;
  yAxis: boolean = true;
  legendTitle = 'Legend';
  autoScale: boolean = true;
  timeline: boolean = true;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private pcs: PageContainerService, private scurve: SCurveService, private dialog: MatDialogRef<ProjectExecutionScurveComponent>) {
    this.setDefaultDates();
  }

  ngOnInit() {
    this.chartData = this.data.chartData;
    this.projectId = this.data.projectId;
    this.project = this.data.project;
    this.executionSummary = this.data.executionSummary;

    this.projectTargetStartMIN = this.getLocalDateString(this.executionSummary.ProjectedStartDate);
    this.projectTargetStart = this.executionSummary.ProjectedStartDate;

    // this.projectTargetFinishMAX = this.getLocalDateString(this.executionSummary.ProjectFinishDate);
    // this.projectTargetFinish = this.executionSummary.ProjectFinishDate;

    this.projectTargetFinishMAX = this.executionSummary.ProjectFinishDate > this.executionSummary.BaselineFinishDate ? this.getLocalDateString(this.executionSummary.ProjectFinishDate) : this.getLocalDateString(this.executionSummary.BaselineFinishDate);
    this.projectTargetFinish = this.executionSummary.ProjectFinishDate > this.executionSummary.BaselineFinishDate ? this.executionSummary.ProjectFinishDate : this.executionSummary.BaselineFinishDate;

    this.baselineTargetFinish = this.executionSummary.BaselineFinishDate;
    this.projectDataDate = this.executionSummary.ProjectDataDate;
    this.projectedData = this.executionSummary.ProjectFinishDate

    if (this.project.ShowFullSchedule) {
      this.seeFullSchedule = true
      this.toggleFullSchedule();
    }
  }

  setDefaultDates() {
    const today = new Date();

    // Three days in the past
    const threeDaysAgo = new Date(today);
    threeDaysAgo.setDate(today.getDate() - 3);

    // Two days in the future
    const twoDaysLater = new Date(today);
    twoDaysLater.setDate(today.getDate() + 2);

    this.startDate = threeDaysAgo.toISOString().split('T')[0];
    this.endDate = twoDaysLater.toISOString().split('T')[0];
  }


  async loadExecutionChartData() {
    let payload: GetExecutionChartCommandRequest = { ProjectId: this.projectId, StartDate: this.startDate, EndDate: this.endDate }
    const response: GetExecutionChartCommandResponse = await this.pcs.apiService.GetExecutionChart(payload, true, false);
    this.chartData = response.Data.ChartData;

    if (this.startDate !== this.getLocalDateString(this.projectTargetStart) || this.endDate !== this.getLocalDateString(this.projectTargetFinish))
      this.seeFullSchedule = false;
    else
      this.seeFullSchedule = true;

    // let lastActualValue = this.chartData[1].series[this.chartData[1].series.length - 1].value;
    // let firstProjectedValue = this.chartData[2].series[0].value;
    // this.chartData[2].series.unshift({
    //   name: this.chartData[2].series[0].name,
    //   value: lastActualValue
    // });
    // this.chartData[2].series[1].value = firstProjectedValue;
  }


  toggleFullSchedule() {
    if (this.seeFullSchedule) {
      this.savedStartDate = this.startDate;
      this.savedEndDate = this.endDate;
      this.startDate = this.getLocalDateString(this.projectTargetStart);
      this.endDate = this.getLocalDateString(this.projectTargetFinish);
    } else {
      this.startDate = this.savedStartDate;
      this.endDate = this.savedEndDate;
    }
    this.loadExecutionChartData();
  }

  closeDialog(): void {
    this.dialog.close();
  }

  getLocalDateString(date: string): string {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(d.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  getSecondValueForDate(model: any) {
    return this.scurve.getSecondValueForDate(this.chartData, model);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/project-execution-scurve/project-execution-scurve.component.ts